import axios from 'axios'
import { applyMiddleware, createStore } from 'redux'
import rootReducer from '../redux/Reducers'
import thunk from 'redux-thunk'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

// import {AUTH_KEY} from "@infoins/auth";

export const axiosInstance = axios.create({
  responseType: 'json',
})

axiosInstance.interceptors.request.use((value) => {
  //old authantication
  // let item = sessionStorage.getItem(AUTH_KEY);

  // if (!!item) {
  //     let resp: any = JSON.parse(item);
  //     if (value?.headers) {
  //         value.headers["Authorization"] = `Bearer ${resp.access_token}`
  //     }
  //     resp.accessToken
  // }
  // return value

  //new authantication

  const item = cookies.get('auth')
  if (!!item) {
    if (value?.headers) {
      value.headers['Authorization'] = `Bearer ${item?.accessToken}`
    }
    item?.accessToken
  }
  return value
})

axiosInstance.interceptors.response.use((value) => {
  return value
})

export const store = createStore(rootReducer, {}, applyMiddleware(thunk))
